<template>
  <b-table
    ref="learning-table"
    class="learning-table sticky-table complex-table"
    :min-width="tableWidth"
    responsive
    :items="items"
    :fields="fields"
    thead-class="d-none"
  >
    <template v-slot:cell(id)="row">
      <div class="circle divide-line-pre">
        <span>{{ row.value }}</span>
      </div>
      <hr class="divide-line divide-line-pre" />
    </template>

    <template v-slot:cell(name)="row">
      <div class="learning-cell content-font-size">{{ row.value }}</div>
      <hr class="divide-line" />
      <div v-for="content in row.item.bookChapters" :key="content.id" v-show="row.item.expanded">
        <div v-for="(detail, index) in content.bigQuestions" :key="detail.id" class="learning-cell content-font-size">
          <template v-if="index == 0">
            {{ content.name }}
          </template>
        </div>
      </div>
    </template>

    <template v-slot:cell(percentage_bar)="row">
      <div class="learning-cell">
        <b-progress :value="row.item.percentage" :max="100" variant="success" />
      </div>
      <hr class="divide-line" />
      <div v-for="content in row.item.bookChapters" :key="content.id" v-show="row.item.expanded">
        <div v-for="(detail, index) in content.bigQuestions" :key="detail.id" class="learning-cell">
          <template v-if="index == 0">
            <b-progress :value="content.percentage" :max="100" variant="success" />
          </template>
        </div>
      </div>
    </template>

    <template v-slot:cell(percentage)="row">
      <div class="learning-cell divide-line-pre">{{ row.value }}%</div>
      <hr class="divide-line" />
      <div v-for="content in row.item.bookChapters" :key="content.id" v-show="row.item.expanded">
        <div v-for="(detail, index) in content.bigQuestions" :key="detail.id" class="learning-cell divide-line-pre">
          <template v-if="index == 0">{{ content.percentage }}%</template>
        </div>
      </div>
    </template>

    <template v-slot:cell(bookChapterId)="row">
      <div class="learning-cell">{{ row.value }}</div>
      <hr class="divide-line" />
      <div v-for="content in row.item.bookChapters" :key="content.id" v-show="row.item.expanded">
        <div v-for="detail in content.bigQuestions" :key="detail.id" class="learning-cell">
          <span :class="completedTypeClassBuilder(detail.completedType)">{{ detail.id }}</span>
        </div>
      </div>
    </template>

    <template v-slot:cell(askTeacher)="row">
      <div class="learning-cell learning-small-header text-center">先生に聞く<br />(任意)</div>
      <hr class="divide-line" />
      <div v-for="content in row.item.bookChapters" :key="content.id" v-show="row.item.expanded">
        <div v-for="detail in content.bigQuestions" :key="detail.id" class="learning-cell text-center">
          {{ detail.askTeacher }}
        </div>
      </div>
    </template>

    <template v-slot:cell(teacherNotify)="row">
      <div class="learning-cell learning-small-header text-center">先生に聞く<br />(強制)</div>
      <hr class="divide-line" />
      <div v-for="content in row.item.bookChapters" :key="content.id" v-show="row.item.expanded">
        <div v-for="detail in content.bigQuestions" :key="detail.id" class="learning-cell text-center">
          {{ detail.teacherNotify }}
        </div>
      </div>
    </template>

    <template v-slot:cell(action)="row">
      <button type="button" class="btn-expand" @click="expandGroup(row.item.id)">
        <template v-if="row.item.expanded">
          <img src="@/assets/images/Icon material-navigate-previous.png" />
        </template>
        <template v-else>
          <img src="@/assets/images/Icon material-navigate-next.png" />
        </template>
      </button>
      <hr class="divide-line divide-line-post" />
    </template>
  </b-table>
</template>

<script>
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
  },
  computed: {
    tableWidth() {
      return sumObjectArrayByKey(this.fields, 'tdAttr', 'width') + 'px';
    },
  },
  methods: {
    completedTypeClassBuilder(completedType) {
      switch (completedType) {
        case 1: // Complete
          return 'square square-big';
        case 2: // Force Complete
          return 'square square-big square-big-green';
        default:
          // Incomplete
          return 'square square-big square-big-gray';
      }
    },
    expandGroup(id) {
      const learningGroup = this.items.find((item) => item.id == id);
      learningGroup.expanded = !learningGroup.expanded;
      this.$refs['learning-table'].refresh();
      this.$logger.debug('Expand for Group: ' + learningGroup.id + ' => ' + learningGroup.expanded);
    },
  },
};
</script>

<style scoped>
.btn-expand {
  background-color: white;
  border: none;
  padding: 0;
  height: 30px;
  width: 30px;
}
.learning-cell {
  height: 30px;
}
.learning-small-header {
  font-size: 10px;
}
.square-big {
  padding: 1px 8px 1px 8px;
  background-color: #e75e58;
  color: white;
  margin-left: 10px;
  font-size: 12px;
}
.square-big-green {
  background-color: #42b195;
}
.square-big-gray {
  background-color: #707070;
}
.content-font-size {
  font-size: 11.5px;
  line-height: 1.2em;
}
</style>
